import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import { EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import { toast } from 'react-toastify'
import ClaimLimitForm from './AddEditClaimLimit'
import CommonSearch from '../../hooks/Search'

const ClaimLimitList = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [claimLimits, setClaimLimits] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const UserId = localStorage.getItem('loggedInUserID')
  useEffect(() => {
    fetchClaimLimits()
  }, [])

  useEffect(() => {
    // Filter data whenever searchTerm or claimLimits changes
    if (searchTerm) {
      const filtered = claimLimits.filter(item =>
        Object.values(item).some(
          val =>
            val &&
            val.toString().toLowerCase().includes(searchTerm.toLowerCase()),
        ),
      )
      setFilteredData(filtered)
    } else {
      setFilteredData(claimLimits)
    }
  }, [searchTerm, claimLimits])

  const fetchClaimLimits = async () => {
    setLoading(true)
    try {
      // Build lookup table: roleId → roleName
      const roleMap = {}

      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/child-roles`,
        'GET',
      )

      if (res.success) {
        let filteredRoles = res?.data.filter(d => d.displayName != null)

        filteredRoles.forEach(item => {
          if (item.id && item.displayName) {
            roleMap[item.id] = item.displayName
          }
        })
      } else {
        toast.error('Failed to fetch roles')
      }






      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Settings/allbyinsurer/${UserId}`,
        'GET',
      )

      if (response.success) {
        const allData = response.data || []


        

        // Map Escalator 1 & Escalator 2
        const mapped = allData.map(item => ({
          ...item,
          esc1Name: item.role || '',                         // Escalator 1
          esc2Name: roleMap[item.multiEscId] || '',          // Escalator 2 resolved from lookup
        }))
        debugger;
        setClaimLimits(mapped)
      } else {
        toast.error(response.message || 'Failed to fetch claim limits')
      }
    } catch (error) {
      toast.error('Error fetching claim limits')
    } finally {
      setLoading(false)
    }
  }



  const handleSearch = value => {
    const filterTable = claimLimits.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setFilteredData(filterTable)
  }
  const ClearSerach = () => {
    setSearchTerm('')
    setClaimLimits(claimLimits)
    fetchClaimLimits()
  }

  const handleCreate = () => {
    setSelectedId(null)
    setModalVisible(true)
  }

  const handleEdit = id => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const handleDelete = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Settings/delete/${id}`,
        'POST',
      )
      if (response.success) {
        toast.success('Claim limit deleted')
        fetchClaimLimits()
      } else {
        toast.error(response.message || 'Delete failed')
      }
    } catch (error) {
      toast.error('Error deleting claim limit')
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchClaimLimits()
  }

  const columns = [
    {
      title: 'Escalator 1',
      dataIndex: 'esc1Name',
      key: 'esc1Name',
    },
    {
      title: 'Escalator 2',
      dataIndex: 'esc2Name',
      key: 'esc2Name',
    },
    {
      title: 'Lower Limit',
      dataIndex: 'lowerLimit',
      key: 'lowerLimit',
    },
    {
      title: 'Upper Limit',
      dataIndex: 'upperLimit',
      key: 'upperLimit',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this claim limit?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No">
            <Tooltip title="Delete">
              <Button type="danger" style={{ marginLeft: 8 }}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]

  return (
    <div title="Claim Limits" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '#0C1362',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                Claim Thresholds Limit List
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <CommonSearch
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              onSearch={handleSearch}
              onClear={ClearSerach}
            />
          </Col>
          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <Button type="primary" onClick={() => handleSearch(searchTerm)}>
              Search
            </Button>
          </Col>
          <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <Button type="primary" onClick={handleCreate}>
              Add Claim Limit
            </Button>
          </Col>
        </Row>
      </div>
      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ marginTop: 20 }}
        />
      ) : (
        <Table columns={columns} dataSource={filteredData} rowKey="id" />
      )}

      <Modal
        title={selectedId ? 'Edit Claim Limit' : 'Add Claim Limit'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <ClaimLimitForm
          brokerID={selectedId}
          modalVisible={modalVisible}
          onSuccess={handleModalClose}
        />
      </Modal>
    </div>
  )
}

export default ClaimLimitList
